











































































import {
  Component, Vue, Watch, mixins, mapState,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  CommonsStore, AdvertisementsStore, Payload, AuthorizationStore, MediaLandingPageStore,
} from '@samclick-store-factory';
import GetLinkDialog from '@/views/Programs/Advertisement/GetLinkDialog.vue';
import { _filter, _find, _isEmpty } from '@samclick-lodash';

class LandingPagesState {
  public casinoID: string | number = ''

  public lpName: string = ''

  public advertisementCategoryId: string = ''

  public country: any
}

@Component({
  /**
   * Imported components
   * */
  components: { GetLinkDialog },
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      campaignList: (state: any) => state.advertisements.advertisementsStore.campaignList,
      landingPages: (state: any) => state.media_landingpage.mediaLandingPageStore.landingPages,
      bannerMapping: (state: any) => state.advertisements.advertisementsStore.adsList,
    }),
  },
  /**
   * Component properties
   * */
  props: {},
})
export default class LandingPages extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
  state = new LandingPagesState();

  SamclickButton = new SamclickMixins().$data.SamclickButton
  SamclickDatatable = new SamclickMixins().$data.SamclickDatatable

  campaignList!: []
  landingPages!: []
  bannerMapping!: []
  /**
   * Watchers
   * */
  @Watch('state.casinoID')
  onCasinoChange() {
    if (!this.state.country) {
      return;
    }
    const allowedCountries = this.countriesForFilter;
    if (!this.isCountryAllowed(this.state.country, allowedCountries)) {
      this.state.country = '';
    }
  }

  /**
   * Methods
   * */
  search() {
    MediaLandingPageStore.getMediaLandingPageList(new Payload({
      status: 1,
      casinoId: this.state.casinoID,
      name: this.state.lpName,
      advertisementCategoryId: this.state.advertisementCategoryId,
      country: this.state.country,
    })); // 31352
  }

  reset() {
    this.state = new LandingPagesState();
    this.search();
  }

  getLink(row: object = {}) {
    const bannerID = _find(this.bannerMapping, { casino_id: row.casinoId});
    const campaignListBasedOnCategory = this.getCampaignListBasedOnCategory();
    if (typeof bannerID === 'undefined' || _isEmpty(campaignListBasedOnCategory)) {
      this.showAlert('You currently don\'t have any campaigns for this category. '
        + 'Kindly create one before proceeding.',
      this.$data.SamclickAlert.WARNING, false).then(() => {
      }).catch(() => {
      });
    } else {
      this.$refs.linkDialog.toggleDialog(true, row, bannerID.id);
    }
  }

  /**
   * Computed
   * */
  get enabledCasinos() {
      return CommonsStore.enabledCasinos;
  }

  get filteredEnabledCasinos() {
      if (!this.state.country || this.state.casinoID) {
          return this.enabledCasinos;
      }

      const selectedCountry = this.getSelectedCountryMatch(this.state.country);

      return this.enabledCasinos.filter((casino: any) => {
          const assignedCountries = this.collectCountriesFromCasino(casino);
          return this.matchesSelectedCountry(assignedCountries, selectedCountry);
      });
  }

  get countriesForFilter() {
    const countries = CommonsStore.activeMarketCountries || [];
    const activeCountries = countries.filter(country => country.is_active === true);

    if (!this.state.casinoID) {
        return activeCountries;
    }

    const selectedCasino = this.enabledCasinos.find(
      (casino: any) => String(casino.id) === String(this.state.casinoID),
    );
    if (!selectedCasino) {
        return activeCountries;
    }
    const assignedCountries = this.collectCountriesFromCasino(selectedCasino);
    const matchSets = this.buildCountryMatchSets(assignedCountries);

    return activeCountries.filter((country: any) => {
        const countryId = country.id !== undefined && country.id !== null ? String(country.id) : null;
        const countryCode = country.country_code ? String(country.country_code) : null;
        return (countryId && matchSets.ids.has(countryId))
            || (countryCode && matchSets.codes.has(countryCode));
    });
  }
  get advertisementCategories() {
    return CommonsStore.allAdvertisementCategories;
  }

  getCampaignListBasedOnCategory() {
    return this.campaignList;
  }

  getCasinoDescription(id: number) {
    return CommonsStore.casinoAllDescription(id) ? CommonsStore.casinoAllDescription(id).code : '';
  }

  private collectCountriesFromCasino(casino: any): any[] {
    if (!casino) {
      return [];
    }

    const countries: any[] = [];
    const pushCountries = (list: any) => {
      if (Array.isArray(list)) {
        countries.push(...list);
      }
    };

    pushCountries(casino.countries);
    pushCountries(casino.market_countries);
    pushCountries(casino.marketCountries);

    if (Array.isArray(casino.markets)) {
      casino.markets.forEach((market: any) => {
        pushCountries(market.countries);
        pushCountries(market.market_countries);
        pushCountries(market.marketCountries);
      });
    }

    return countries;
  }

  private buildCountryMatchSets(countries: any[]) {
    const ids = new Set<string>();
    const codes = new Set<string>();

    countries.forEach((country: any) => {
      const id = country
        ? (country.id !== undefined && country.id !== null ? country.id
          : (country.country_id !== undefined && country.country_id !== null ? country.country_id
            : (country.countryId !== undefined && country.countryId !== null ? country.countryId : null)))
        : null;
      const code = country
        ? (country.country_code ? country.country_code
          : (country.code ? country.code
            : (country.countryCode ? country.countryCode : null)))
        : null;
      if (id !== undefined && id !== null) {
        ids.add(String(id));
      }
      if (code) {
        codes.add(String(code));
      }
    });

    return { ids, codes };
  }

  private getSelectedCountryMatch(country: any) {
    if (country && typeof country === 'object') {
      const id = country.id !== undefined && country.id !== null ? country.id
        : (country.country_id !== undefined && country.country_id !== null ? country.country_id
          : (country.countryId !== undefined && country.countryId !== null ? country.countryId : null));
      const code = country.country_code ? country.country_code
        : (country.code ? country.code
          : (country.countryCode ? country.countryCode : null));
      return { id, code };
    }

    return { id: country, code: null };
  }

  private matchesSelectedCountry(countries: any[], selected: { id: any; code: any }) {
    if (!selected || (selected.id === null && !selected.code)) {
      return false;
    }
    const matchSets = this.buildCountryMatchSets(countries);
    if (selected.id !== undefined && selected.id !== null) {
      return matchSets.ids.has(String(selected.id));
    }
    if (selected.code) {
      return matchSets.codes.has(String(selected.code));
    }
    return false;
  }

  private isCountryAllowed(selectedCountry: any, allowedCountries: any[]) {
    if (!selectedCountry) {
      return false;
    }
    const selectedMatch = this.getSelectedCountryMatch(selectedCountry);
    if (selectedMatch.id === null && !selectedMatch.code) {
      return false;
    }
    return allowedCountries.some((country: any) => {
      const countryId = country.id !== undefined && country.id !== null ? String(country.id) : null;
      const countryCode = country.country_code ? String(country.country_code) : null;
      if (selectedMatch.id !== null && selectedMatch.id !== undefined && countryId) {
        return countryId === String(selectedMatch.id);
      }
      if (selectedMatch.code && countryCode) {
        return countryCode === String(selectedMatch.code);
      }
      return false;
    });
  }

  /**
   * Lifecycle hooks
   * */
  created() {
    AdvertisementsStore.getCampaignList(new Payload({ affiliateId: AuthorizationStore.currentLoggedUserInState.id, status: 1 }));
    this.search();

    AdvertisementsStore.getAdvertismentList(new Payload({ types: 2, orderby: 'date_desc' }));
  }

  getAdvertisementCategoryName(advertisementCategoryId: number) {
    return CommonsStore.advertisementCategoryName(advertisementCategoryId);
  }

  mounted() {}

  beforeUpdate() {}
}
